import { BannerData, ServiceData, ServiceImageData, FavoriteRecipeClip, FoodRecommendationListData } from "@/types/home";
import { CommonRecipe, CommonRecipeTag, CommonRecipeFoodId } from "@/types/commonRecipe";
import { Recipe } from "@/types/recipes";

// バナー一覧ダミー
export const dummyBannerList: Array<BannerData> = [
  {
    id: 0,
    imageUrl: require("@/assets/images/feature_dummy.png"),
    contentsUrl:
      "https://cdn.dev1.kitchen-appliances-pf.com/KadenContents/Microwave/UBS5A/MWCNT_2_RecipeList/MWCNT_2_RecipeList_OfficialRecipeWin.html",
    externalContentsFlg: false
  },
  {
    id: 1,
    imageUrl: require("@/assets/images/feature_dummy.png"),
    contentsUrl:
      "https://cdn.dev1.kitchen-appliances-pf.com/KadenContents/Microwave/UBS5A/MWCNT_2_RecipeList/MWCNT_2_RecipeList_OfficialRecipeWin.html",
    externalContentsFlg: false
  },
  {
    id: 2,
    imageUrl: require("@/assets/images/feature_dummy.png"),
    contentsUrl:
      "https://cdn.dev1.kitchen-appliances-pf.com/KadenContents/Microwave/UBS5A/MWCNT_2_RecipeList/MWCNT_2_RecipeList_OfficialRecipeWin.html",
    externalContentsFlg: false
  }
];

export const dummyServiceImageList: Array<ServiceImageData> = [
  {
    top: require("@/assets/images/service_4.png"),
    thumb: require("@/assets/images/service_4.png")
  }
];

// サービス一覧ダミー
export const dummyServiceList: Array<ServiceData> = [
  {
    id: 0,
    title: "コラボレシピ",
    description: "a<br/>a<br/>",
    image: {
      top: require("@/assets/images/service_1.png"),
      thumb: require("@/assets/images/service_1.png")
    },
    contentsUrl: "",
    externalContentsFlg: false
  },
  {
    id: 1,
    title: "誰か教えて",
    description: "",
    image: {
      top: require("@/assets/images/service_2.png"),
      thumb: require("@/assets/images/service_2.png")
    },
    contentsUrl: "",
    externalContentsFlg: false
  },
  {
    id: 2,
    title: "Foodable",
    description: "",
    image: {
      top: require("@/assets/images/service_3.png"),
      thumb: require("@/assets/images/service_3.png")
    },
    contentsUrl: "",
    externalContentsFlg: false
  },
  {
    id: 4,
    title: "EATPICK",
    description: "",
    image: {
      top: require("@/assets/images/service_4.png"),
      thumb: require("@/assets/images/service_4.png")
    },
    contentsUrl: "",
    externalContentsFlg: false
  }
];

/** お気に入り系のAPIのレスポンスから、共通レシピ一覧への変換 */
export const createFavoriteRecipeToCommonRecipe = (clip: FavoriteRecipeClip) => {
  const element: CommonRecipe = new CommonRecipe();
  element.recipeId = clip.recipeId;
  element.groupId = clip.groupId;
  element.title = clip.caption;
  element.imageUrl = clip.imageUrl;
  element.type = clip.type;
  element.applianceCategory = clip.device;
  element.applianceCategoryId = clip.applianceCategoryId;
  element.productId = clip.productId;
  element.tags = [];
  for (const tag of clip.tags) {
    element.tags.push(new CommonRecipeTag(tag.id, tag.name));
  }
  return element;
}

export const getFoodIdIcon = (foodId: number, foodRecommendationListData: FoodRecommendationListData) => {
  let result = null;
  if (foodRecommendationListData.response && foodRecommendationListData.response.foods) {
    for (const item of foodRecommendationListData.response.foods) {
      if (foodId == item.foodId) {
        result = item.icon;
        break;
      }
    }
  }
  return result;
};

export const getFoodIds = (recipe: Recipe, foodRecommendationListData: FoodRecommendationListData) => {
  const foodIds = new Array<CommonRecipeFoodId>();
  if (recipe && recipe.usedRequiredFoods) {
    for (const foodId of recipe.usedRequiredFoods) {
      const icon = getFoodIdIcon(foodId, foodRecommendationListData);
      if (icon == null) {
        continue;
      }
      const food = new CommonRecipeFoodId(foodId, icon);
      foodIds.push(food);
    }
  }
  return foodIds;
};

export const getRecommendFoodList = (foodRecommendationListData: FoodRecommendationListData) => {
  const foodList = Array<string>();
  if (foodRecommendationListData.response != null) {
    for (const item of foodRecommendationListData.response.foods) {
      if (item.foodId) {
        foodList.push("" + item.foodId);
      }
    }
  }
  return foodList;
};
